document.addEventListener('DOMContentLoaded', function() {
  // Find all elements with the class "gfield-choice-input"
  var choiceInputs = document.getElementsByClassName('gfield_checkbox');

  // Attach event listeners to each choice input
  for (var i = 0; i < choiceInputs.length; i++) {
    choiceInputs[i].addEventListener('change', toggleCheckedClass);
  }
});

function toggleCheckedClass(event) {
  var choiceInput = event.target;
  var checkboxContainer = choiceInput.closest('.gfield_checkbox');

  if (choiceInput.checked) {
    checkboxContainer.classList.add('gfield_checkbox-checked');
  } else {
    checkboxContainer.classList.remove('gfield_checkbox-checked');
  }
}